<template>
    <div class="w-full -mt-2">
        <input-radio-boolean
            :name="'tenant[' + tenant.id + '][has_long_term_obligations]'"
            v-model="has_long_term_obligations"
            true="Yes"
            false="No"
            class="pt-2"
            :read_only="read_only"
        />

        <div v-if="has_long_term_obligations">
            <tenant-long-term-obligations-details
                :read_only="read_only"
                :tenant="tenant"
            />
        </div>
    </div>
</template>

<script>
import TenantLongTermObligationsDetails from './tenant-long-term-obligations-details.vue';

export default {
    components: {
        TenantLongTermObligationsDetails,
    },

    props: {
        read_only: { default: false },
        property: {},
        tenant: {},
    },

    computed: {
        has_long_term_obligations: {
            get() {
                return this.tenant.has_long_term_obligations;
            },
            set(value) {
                this.tenant.has_long_term_obligations = value;
            },
        },
    },
}
</script>
